/* Dondersteen: show ONLY media assigned to selected variant (Shopify variant_ids); keep unassigned media visible */
(function () {
  function getSelectedVariantId(root) {
    // Shopify standard: hidden input name="id" inside product form
    const input = root.querySelector('form[action^="/cart/add"] [name="id"]');
    return input && input.value ? String(input.value).trim() : null;
  }

  function getFlickity(root) {
    if (!window.Flickity) return null;
    const slider =
      root.querySelector('[data-product-slideshow].flickity-enabled') ||
      root.querySelector('.product__slides.flickity-enabled') ||
      root.querySelector('.flickity-enabled');
    if (!slider) return null;
    return window.Flickity.data(slider) || null;
  }

  function applyFilter() {
    const root = document;
    const variantId = getSelectedVariantId(root);
    if (!variantId) return;

    // Target slides that have Shopify-provided variant binding
    const slides = Array.from(
      root.querySelectorAll('.product__slide[data-slide][data-variant-ids], .product__slide[data-slide][data-image-id][data-variant-ids], [data-variant-ids][data-media-id]')
    );

    if (!slides.length) return;

    let visible = [];

    slides.forEach((slide) => {
      const idsRaw = (slide.getAttribute('data-variant-ids') || '').trim();

      // If no ids are present, treat as universal media
      if (!idsRaw) {
        slide.classList.remove('ds-variant-hidden');
        slide.classList.remove('media--hidden');
        visible.push(slide);
        return;
      }

      const ids = idsRaw.split(',').map(v => v.trim()).filter(Boolean);
      const shouldShow = ids.includes(String(variantId));

      // Use our own class (safer) and also honor Broadcast's hidden class if you’re already using it
      slide.classList.toggle('ds-variant-hidden', !shouldShow);
      slide.classList.toggle('media--hidden', !shouldShow);

      if (shouldShow) visible.push(slide);
    });

    // Safety: never allow the gallery to go empty
    if (!visible.length) {
      slides.forEach((s) => {
        s.classList.remove('ds-variant-hidden');
        s.classList.remove('media--hidden');
      });
      visible = slides;
    }

    // If active slide got hidden, move active to first visible
    const active = root.querySelector('.product__slide.media--active');
    const firstVisible = visible[0];
    if (active && (active.classList.contains('ds-variant-hidden') || active.classList.contains('media--hidden')) && firstVisible) {
      active.classList.remove('media--active');
      firstVisible.classList.add('media--active');
    }

    // Refresh slider
    const flkty = getFlickity(root);
    if (flkty) {
      flkty.reloadCells();
      flkty.resize();

      const firstVisibleSlide = root.querySelector('.product__slide[data-slide]:not(.ds-variant-hidden):not(.media--hidden)');
      if (firstVisibleSlide) {
        const idx = flkty.cells.findIndex((cell) => cell.element === firstVisibleSlide);
        if (idx >= 0) flkty.select(idx, false, true);
      }
    }

    window.dispatchEvent(new Event('resize'));
  }

  function init() {
    applyFilter();

    // Some themes dispatch this
    document.addEventListener('variant:change', function () {
      setTimeout(applyFilter, 0);
    });

    // Generic fallback: any change inside variants UI, then filter after theme updates hidden id input
    document.addEventListener('change', function (e) {
      const t = e && e.target;
      if (!t) return;
      if (t.matches('[data-single-option-selector]') || t.closest('[data-product-variants]')) {
        setTimeout(applyFilter, 0);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
